'use strict';

var $ = require('jquery');
var submitApi = require('../api/submit-api.js');
var logger = require('../utils/logger.js');
var analytics = require('../utils/analytics.js');

var classNames = {
	alertBox: 'alert-box',
	contactDealer: 'contact-dealer',
	requestForm: 'request-form',
	requestFormValidationSummary: 'request-form__validation-summary',
	submitError: 'submit-error',
	submitSuccess: 'submit-success',
	submitButton: 'submit-button',
	askDealerAQuestionShowFormTrigger: 'ask-dealer-a-question-form-trigger',
	askDealerAQuestionMessageTemplate: 'ask-dealer-a-question-message-template',
	contactDealerShowFormTrigger: 'show-contact-dealer-form-trigger',
	contactDealerMessageTemplate: 'contact-dealer-message-template',
	emailDealer: 'email-dealer',
	emailDealerTemplate: 'email-dealer-template',
	requestPhotos: 'request-photos',
	requestPhotosTemplate: 'request-photos-template',
	requestPhotosFromGalleryShowFormTrigger: 'show-request-photos-from-gallery-form-trigger',
	requestPhotosFromGalleryMessageTemplate: 'request-photos-from-gallery-template',
	close: 'close'
};

var trackingCategory = {
	defaultEmailDealer: 'Email Dealer',
	defaultRequestPhotos: 'Request Photos',
	defaultAskDealerQuestion: 'Ask Dealer Question'
};

var trackingAction = {
	successMessage: 'Submit Message',
	successMessageGallery: 'Submit Message (from gallery)',
	failMessage: 'Message Send Fail',
	failMessageGallery: 'Message Send Fail (from gallery)'
};

var trackingData = {
	emailDealer: {
		category: trackingCategory.defaultEmailDealer,
		actionSuccess: trackingAction.successMessage,
		actionFail: trackingAction.failMessage
	},
	emailDealerGallery: {
		category: trackingCategory.defaultEmailDealer,
		actionSuccess: trackingAction.successMessageGallery,
		actionFail: trackingAction.failMessageGallery
	},
	requestPhotos: {
		category: trackingCategory.defaultRequestPhotos,
		actionSuccess: trackingAction.successMessage,
		actionFail: trackingAction.failMessage
	},
	requestPhotosGallery: {
		category: trackingCategory.defaultRequestPhotos,
		actionSuccess: trackingAction.successMessageGallery,
		actionFail: trackingAction.failMessageGallery
	},
	askDealerQuestion: {
		category: trackingCategory.defaultAskDealerQuestion,
		actionSuccess: trackingAction.successMessage,
		actionFail: trackingAction.failMessage
	},
};

var $modal;
var $form;
var $formMessageInput;
var $formMessageType;

var tracking = {
	getData: function () {
		var $submitMessageButton = $.findByBem(classNames.contactDealer, classNames.submitButton);

		// clear jQuery's internal cache before fetching the data value.
		$($submitMessageButton).removeData('ga');
		return $($submitMessageButton).data('ga');
	},

	trackEvent: function (messageSent) {
		var trackingData = tracking.getData();

		if (!trackingData) {
			return;
		}

		var eventAction = messageSent ? trackingData.actionSuccess : trackingData.actionFail;
		analytics.trackEvent(trackingData.category, eventAction, trackingData.stockId);
	}
};

var contactForm = {
	init: function () {
		$modal = $('#contactDealerModal');

		$form = $.findByBem(classNames.contactDealer, classNames.requestForm);
		if ($form.length === 0) {
			logger.error('CFS: Contact dealer form could not be initialised');
			$modal.foundation('reveal', 'close');
			return;
		}

		$formMessageInput = $form.find('textarea[name="message"]');
		$formMessageType = $form.find('input[name="messageType"]');

		contactForm.setLayout();
		contactForm.setControls();
	},

	setLayout: function () {
		$.findByBem(classNames.contactDealer, classNames.submitError).hide();
		$.findByBem(classNames.contactDealer, classNames.submitSuccess).hide();
	},

	send: function () {
		var disabledClass = $.getBemClass(classNames.contactDealer, classNames.submitButton, 'submitting');
		$.findByBem(classNames.contactDealer, classNames.submitButton).disable(disabledClass);

		submitApi.submitDealerContact($form.serialize(), {
			successCallback: function () {
				$($form).slideUp();
				$.findByBem(classNames.contactDealer, classNames.submitSuccess).show();

				var messageSent = true;
				tracking.trackEvent(messageSent);
			},
			errorCallback: function () {
				$.findByBem(classNames.contactDealer, classNames.submitError).show();

				var messageSent = false;
				tracking.trackEvent(messageSent);
			},
			completeCallback: function () {
				$.findByBem(classNames.contactDealer, classNames.submitButton).enable(disabledClass);
			}
		});
	},

	setControls: function () {
		var self = this;

		function setShowFormTriggerHandler(showFormTriggerClassNames, messageTemplateClassNames, trackingData) {
			var $trigger = $.findByBem.apply(null, showFormTriggerClassNames);

			$trigger.on('click', function (e) {
				e.preventDefault();

				var $messageTemplate = $.findByBem.apply(null, messageTemplateClassNames);
				if ($messageTemplate.length === 0) {
					return;
				}

				var messageTemplate = $messageTemplate.text().trim();
				$formMessageInput.val(messageTemplate);

				var messageType = $messageTemplate.data('message-type');
				$formMessageType.val(messageType);

				var formTriggerElement = e.currentTarget;
				self.attachSubmitMessageTracking(formTriggerElement, trackingData);

				$modal.foundation('reveal', 'open');
			});
		}

		// reset the form when the modal opens.
		$(document).on('opened.fndtn.reveal', '#contactDealerModal[data-reveal]', function () {
			self.reset();
		});

		$.findByBem(classNames.contactDealer, classNames.submitButton).on('click', function () {
			$.findByBem(classNames.contactDealer, classNames.alertBox).hide();
		});

		setShowFormTriggerHandler(
			[classNames.askDealerAQuestionShowFormTrigger],
			[classNames.contactDealer, classNames.askDealerAQuestionMessageTemplate],
			trackingData.askDealerQuestion);

		setShowFormTriggerHandler(
			[classNames.contactDealerShowFormTrigger],
			[classNames.contactDealer, classNames.contactDealerMessageTemplate],
			trackingData.emailDealerGallery);

		setShowFormTriggerHandler(
			[classNames.contactDealer, classNames.emailDealer],
			[classNames.contactDealer, classNames.emailDealerTemplate],
			trackingData.emailDealer);

		setShowFormTriggerHandler(
			[classNames.contactDealer, classNames.requestPhotos],
			[classNames.contactDealer, classNames.requestPhotosTemplate],
			trackingData.requestPhotos);

		setShowFormTriggerHandler(
			[classNames.requestPhotosFromGalleryShowFormTrigger],
			[classNames.contactDealer, classNames.requestPhotosFromGalleryMessageTemplate],
			trackingData.requestPhotosGallery);

		$.findByBem(classNames.contactDealer, classNames.close).on('click', function () {
			$modal.foundation('reveal', 'close');
		});
	},

	reset: function () {
		$form.find('input')
			.not(':button, :submit, :input[name="postcode"], :input[type="hidden"], textarea')
			.val('');

		$.findByBem(classNames.contactDealer, classNames.alertBox).hide();

		if ($($form).not(':visible')) {
			$($form).slideDown();
		}
	},

	attachSubmitMessageTracking: function(formTriggerElement, trackingData) {
		if (!formTriggerElement || !trackingData) {
			return;
		}

		var $submitMessageButton = $.findByBem(classNames.contactDealer, classNames.submitButton);

		// Each of the buttons that triggers the submit message form has tracking data for other events.
		// The tracking categories from those are all relevant to this tracking.
		// Hence, we can retrieve and apply those categories here.
		var gaTracking = $(formTriggerElement).data('ga-track');

		if (gaTracking) {
			trackingData.category = gaTracking.category;

			// label contains car stock Id or VFS Id
			trackingData.stockId = gaTracking.label;
		}

		$($submitMessageButton).attr('data-ga', JSON.stringify(trackingData));
	}
};

var validation = {
	init: function () {
		validation.addEmailValidator();
		validation.addPhoneValidator();
		validation.addPostcodeValidator();

		var $validationSummary = $.findByBem(classNames.contactDealer, classNames.requestFormValidationSummary).hide();

		$form.validate({
			rules: {
				firstName: { required: true },
				lastName: { required: true },
				email: {
					required: true,
					emailValid: true
				},
				phoneNumber: {
					required: false,
					phoneValid: true
				},
				postcode: {
					required: false,
					postcodeValid: true
				}
			},
			messages: {
				firstName: 'First Name is required.',
				lastName: 'Last Name is required.',
				email: { required: 'Email is required.' }
			},
			errorPlacement: function (error, $element) {
				error.insertAfter($element);
				error.addClass('alert-box alert');
				error.addBemClass(classNames.ownerReviewForm, 'validation-error');
			},
			focusInvalid: false,
			invalidHandler: function () {
				$validationSummary.show();
			},
			submitHandler: function (form, event) {
				event.preventDefault();
				$validationSummary.hide();
				contactForm.send();
			}
		});
	},

	addPhoneValidator: function () {
		$.validator.addMethod('phoneValid', function (value) {
			if (value === '') {
				return true;
			}

			return value.match(/^[\d\s]+$/);
		}, 'Please enter a valid phone number.');
	},

	addPostcodeValidator: function () {
		$.validator.addMethod('postcodeValid', function (value) {
			if (value === '') {
				return true;
			}

			return value.match(/^((((([A-PR-UWYZ][0-9][0-9A-HJKS-UW]?)|([A-PR-UWYZ][A-HK-Y][0-9][0-9ABEHMNPRV-Y]?))\s{0,1}[0-9]([ABD-HJLNP-UW-Z]{2}))|(GIR\s{0,2}0AA)))$/i);
		}, 'Please enter a valid postcode.');
	},

	addEmailValidator: function () {
		$.validator.addMethod('emailValid', function (value) {
			return value.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);
		}, 'Please enter a valid email address');
	},
};

module.exports = {
	init: function () {
		contactForm.init();
		validation.init();
	}
};